export const VoucherEditSceneTranslation = {
  fi: {
    VoucherEditScene: {
      title: 'Muokkaa kuponkia',
    },
  },
};
